import React from "react";
import { ITransformerReading } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import {
  IStackTokens,
  PanelType,
  Stack,
  DefaultButton,
  PrimaryButton,
  Dropdown,
  Toggle,
} from "office-ui-fabric-react";
import CustomDrawer from "../../common/CustomDrawer";
import * as yup from "yup";
import { Formik } from "formik";
import { updateTransformerReading } from "../../../services/infrastructure/TransformerService";
import { CustomTextField } from "../../common/Library";
import { CategoryHeader } from "../Misc";
import { getAlertDetails } from "../../../services/ThresholdService";

import {
  TRANSFORMER_COLOUR,
  TRANSFORMER_OIL_LEVEL,
} from "../../common/Constants";

const rtccStatus = yup.object().shape({
  tapPosition: yup.number().required("required"),
  refVoltage: yup.number().required("required"),
});

const transformerReadingSchemaForTypeOil = yup.object().shape({
  windTemperature: yup.number().required("required"),
  oilTemperature: yup.number().required("required"),
  // oilLevel: yup.string().required("required"),
  noOfCounter: yup.number().required("required"),
  rtccStatus: rtccStatus,
  recordedBy: yup.string().required("required"),
  remarks: yup.string().optional(),
});

const transformerReadingSchemaForTypeDry = yup.object().shape({
  channel1Temp: yup.number().required("required"),
  channel2Temp: yup.number().required("required"),
  channel3Temp: yup.number().required("required"),
  channel4Temp: yup.number().required("required"),
  channel5Temp: yup.number().required("required"),
  channel6Temp: yup.number().required("required"),
  recordedBy: yup.string().required("required"),
  remarks: yup.string().optional(),
});

export interface ManageTransformerDialogProps {
  data?: ITransformerReading;
  handleLoading: any;
  handleDialogClose: any;
  threshold: any;
}

const ManageTransformerDialog: React.FC<ManageTransformerDialogProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  threshold,
}) => {
  //state
  const [state, setState] = React.useState({
    transformerReading: {
      ...data,
    },
    isLoading: false,
  } as {
    transformerReading: ITransformerReading;
    isLoading: boolean;
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 4 };

  const closeUpdateDialoge = (data?: ITransformerReading) => {
    handleDialogClose(data);
  };

  const onBlurFunc = (value: any, path: string) => {
    console.log("onBlurFunc");
    const { showAlert, msg } = getAlertDetails(path, threshold, value);
    console.log("[showAlert]", showAlert, msg);
    if (showAlert === true) {
      showConfirmDialog("Alert", msg as string, () => { }, "Ok", true);
    }
  };
  return (
    <React.Fragment>
      <CustomDrawer
        drawerType={PanelType.medium}
        title={"Update Transformer Reading"}
        handelOpen={true}
        onClose={() => closeUpdateDialoge()}
      >
        <Stack>
          <Formik
            initialValues={state.transformerReading}
            // validationSchema={
            //   state.transformerReading.transformerType === "oil"
            //     ? transformerReadingSchemaForTypeOil
            //     : transformerReadingSchemaForTypeDry
            // }
            onSubmit={async (
              values: ITransformerReading,
              { setSubmitting }
            ) => {
              let obj = { ...values };
              let result;
              handleLoading();
              result = await updateTransformerReading(obj);
              handleLoading();
              if (result?.success) {
                closeUpdateDialoge(result.data);
                showToast(
                  `Transformer Reading updated successfully`,
                  "success"
                );
              } else {
                showToast(
                  `Error while updating an Transformer reading`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, values, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={wrapStackTokens}>
                  <Stack.Item className="custom-toggle">
                    <Toggle
                      checked={values.isSystemOn}
                      onText="On"
                      offText="Off"
                      onChange={(e, v) => setFieldValue("isSystemOn", v)}
                      label="System"
                    />
                  </Stack.Item>
                  {state.transformerReading.transformerType === "oil" && (
                    <>
                      <Stack.Item>
                        <CustomTextField
                          name={"windTemperature"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Winding Temp."}
                        />
                      </Stack.Item>

                      <Stack.Item>
                        <CustomTextField
                          name={"oilTemperature"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Temp."}
                        />
                      </Stack.Item>

                      <Stack.Item className="custom-dropdown mb-30">
                        <Dropdown
                          options={TRANSFORMER_OIL_LEVEL}
                          selectedKey={values.oilLevel}
                          onChange={(e, v) => setFieldValue("oilLevel", v?.key)}
                          label="Oil Level in Conservator"
                          placeholder="Select an option"
                        />
                      </Stack.Item>

                      <Stack.Item className="custom-dropdown mb-30">
                        <Dropdown
                          options={TRANSFORMER_COLOUR}
                          selectedKey={values.colourOfSilicaGen}
                          onChange={(e, v) =>
                            setFieldValue("colourOfSilicaGen", v?.key)
                          }
                          label="Colour of Silica Gel"
                          placeholder="Select an option"
                        />
                      </Stack.Item>

                      <Stack.Item>
                        <CategoryHeader title="Others" />
                        <Stack
                          tokens={wrapStackTokens}
                          horizontal
                          wrap
                          horizontalAlign="space-between"
                          className="pt-24"
                        >
                          <Stack.Item className="custom-toggle">
                            <Toggle
                              checked={values.oilLeakage}
                              onText="Yes"
                              offText="No"
                              onChange={(e, v) =>
                                setFieldValue("oilLeakage", v)
                              }
                              label="Oil Leakage (If any)"
                            />
                          </Stack.Item>
                          <Stack.Item className="custom-toggle">
                            <Toggle
                              checked={values.explosionVent}
                              onText="Yes"
                              offText="No"
                              onChange={(e, v) =>
                                setFieldValue("explosionVent", v)
                              }
                              label="Explosion Vent (Oil in Window)"
                            />
                          </Stack.Item>
                          <Stack.Item>
                            <span></span>
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>

                      <Stack.Item>
                        <CustomTextField
                          name={"noOfCounter"}
                          type="number"
                          label={"No. of Counter"}
                        />
                      </Stack.Item>

                      <Stack.Item>
                        <CategoryHeader title="RTCC Status" />
                        <Stack
                          horizontal
                          wrap
                          tokens={wrapStackTokens}
                          className="pt-24"
                        >
                          <Stack.Item grow={1}>
                            <CustomTextField
                              name={"rtccStatus.tapPosition"}
                              type="number"
                              label={"Tap Position"}
                            />
                          </Stack.Item>
                          <Stack.Item grow={1}>
                            <CustomTextField
                              name={"rtccStatus.refVoltage"}
                              type="number"
                              label={"Ref. Voltage"}
                            />
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>
                    </>
                  )}

                  {state.transformerReading.transformerType === "dry" && (
                    <>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel1Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 1"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel1Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 1"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel2Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 2"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel3Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 3"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel4Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 4"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel5Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 5"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"channel6Temp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp - Channel 6"}
                        />
                      </Stack.Item>
                    </>
                  )}

                  <Stack.Item>
                    <CategoryHeader title="General" />
                    <Stack tokens={wrapStackTokens} className="pt-24">
                      <Stack.Item>
                        <CustomTextField
                          name={"remarks"}
                          label={"Remarks (If Any)"}
                          multiline
                          autoAdjustHeight
                        />
                      </Stack.Item>
                      <Stack.Item className="pt-24">
                        <CustomTextField
                          name={"recordedBy"}
                          label={"Shift Tech Sign"}
                          disabled={true}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>
                  <br />
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={wrapStackTokens}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeUpdateDialoge()}
                        className="borderless-btn"
                      />
                      <PrimaryButton type="submit" text="Update" />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageTransformerDialog;
